import React from "react";
import {
    Navigate,
} from "react-router-dom";

const EquipmentListComponent = React.lazy(() => import("../../../../../components/equipments/components/list/page"));
const EquipmentAddComponent = React.lazy(() => import("../../../../../components/equipments/components/add/page"));

export const equipmentRoute = [
    {
        path: 'list',
        element: <EquipmentListComponent />
    },
    {
        path: 'add',
        element: <EquipmentAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/store/equipments/add" />
    },
    {
        path: 'edit/:id',
        element: <EquipmentAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/store/equipments/list" />
    },
];